import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import './AdminPanel.css';

const AdminManagement = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // New admin form
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newRole, setNewRole] = useState('admin');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    loadAdmins();
  }, []);

  const loadAdmins = async () => {
    try {
      setLoading(true);
      const data = await apiService.getAdmins();
      setAdmins(data.admins || []);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load admins');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAdmin = async (e) => {
    e.preventDefault();
    setCreating(true);
    try {
      await apiService.createAdmin(newUsername, newPassword, newRole);
      setNewUsername('');
      setNewPassword('');
      setNewRole('admin');
      loadAdmins();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to create admin');
    } finally {
      setCreating(false);
    }
  };

  const handleRoleChange = async (adminId, newRole) => {
    try {
      await apiService.updateAdminRole(adminId, newRole);
      loadAdmins();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to update role');
    }
  };

  const handleDeleteAdmin = async (id) => {
    if (!window.confirm("Are you sure you want to delete this admin?")) return;
    try {
      await apiService.deleteAdmin(id);
      loadAdmins();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete admin');
    }
  };

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading admins...</div>;
  }

  return (
    <div style={{ marginTop: '2rem' }}>
      <div className="admin-header" style={{ marginBottom: '1rem', padding: '1.5rem' }}>
        <h3>👑 Master Control: Manage Admins</h3>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="admin-management-grid">
        <div style={{ flex: 1, background: 'white', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}>
          <h4>Add New Admin</h4>
          <form onSubmit={handleCreateAdmin}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Username</label>
              <input
                type="text"
                value={newUsername}
                onChange={(e) => setNewUsername(e.target.value)}
                required
                style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #cbd5e1' }}
              />
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #cbd5e1' }}
              />
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Role</label>
              <select
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                style={{ width: '100%', padding: '0.5rem', borderRadius: '6px', border: '1px solid #cbd5e1' }}
              >
                <option value="admin">Full Admin</option>
                <option value="viewer">Viewer (Limited Access)</option>
              </select>
            </div>
            <button 
              type="submit" 
              disabled={creating}
              className="view-btn"
              style={{ width: '100%' }}
            >
              {creating ? 'Creating...' : '+ Create Admin'}
            </button>
          </form>
        </div>

        <div style={{ flex: 2, background: 'white', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}>
          <h4>Active Admins</h4>
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Username</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {admins.map(admin => (
                <tr key={admin.id}>
                  <td>#{admin.id}</td>
                  <td><strong>{admin.username}</strong></td>
                  <td>
                    {admin.is_master ? (
                      <span className="badge badge-valid">👑 Master</span>
                    ) : (
                      <select
                        value={admin.role || 'admin'}
                        onChange={(e) => handleRoleChange(admin.id, e.target.value)}
                        style={{ padding: '0.3rem', borderRadius: '4px', border: '1px solid #ccc' }}
                      >
                        <option value="admin">Admin</option>
                        <option value="viewer">Viewer</option>
                      </select>
                    )}
                  </td>
                  <td>
                    {!admin.is_master && (
                      <button 
                        onClick={() => handleDeleteAdmin(admin.id)}
                        style={{ background: '#ef4444', color: 'white', border: 'none', padding: '0.4rem 0.8rem', borderRadius: '4px', cursor: 'pointer' }}
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminManagement;
